import { useState, useEffect } from "react";
import PageTitle from "../components/PageTitle";
import Index from "../view/BookingSuccess/Index";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import { setCartClear } from "../redux/cart/cart.action";
import helper, { getSlugByLang } from "../common/Helper";
import axios from "axios";
import HomeIcon from "../components/Iocns/HomeIcon";

export default function BookingSuccessController() {

    const [bookingDetail, setBookingDetail] = useState({})
    const user = useSelector((state) => state.user);
    const perems = useParams();
    const [breadcrumbList, setBreadcrumbList] = useState([
        {
            name: <HomeIcon />,
            url: "/"
        },
        {
            name: "Booking Details",
        },

    ])
    const [isTicketGenerated, setIsTicketGenerated] = useState(false);
    const [ticketFullPath, setTicketFullPath] = useState(false);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState("");

    const getRecordDetails = async (id) => {
        setIsLoading(true)
        const fetchrecordDetail = await ApiCall('get', 'get-booking-detail/' + id, null, user.token)
        if (fetchrecordDetail) {
            if (fetchrecordDetail?.data?.success) {
                setBookingDetail(fetchrecordDetail.data.booking)
                setIsLoading(false)

            } else {
                navigate('/')
            }
        } else {
            navigate('/')
        }
    };

    const checkTicket = async (id) => {
        const checkTicketStatus = await ApiCall('post', 'bookings/check-ticket', { bookingId: id }, user.token)
        if (checkTicketStatus) {
            setIsTicketGenerated(checkTicketStatus?.data?.success)
            setTicketFullPath(checkTicketStatus?.data?.fullPath)
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isTicketGenerated && bookingDetail?.id) {
                checkTicket(bookingDetail?.id)
            } else {
                clearInterval(interval);
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [isTicketGenerated, bookingDetail?.id]);

    useEffect(() => {
        dispatch(setCartClear())
    }, []);
    useEffect(() => {
        let sl = getSlugByLang(user?.language)
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: "/" + sl
            },
            {
                name: "Booking Details",
            },
        ])
    }, [user?.language]);


    useEffect(() => {
        (async () => {
            if (perems.id) {
                await getRecordDetails(perems.id)
            }
        })();
    }, [perems.id]);



    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // const downloadMultipleFiles = async () => {
    //     try {
    //         const response = await axios.post(
    //             helper.ApiUrl + 'bookings/genrate-tickets',
    //             { bookingId: perems.id },
    //             {
    //                 headers: {
    //                     'Authorization': `Bearer ${user.token}`,
    //                     'Accept': 'application/json',
    //                 },
    //             }
    //         );

    //         const links = response.data;

    //         for (const url of links) {
    //             const iframe = document.createElement('iframe');
    //             iframe.style.display = 'none';
    //             iframe.src = url + '&response-content-disposition=attachment';
    //             document.body.appendChild(iframe);
    //             await delay(1000);
    //             document.body.removeChild(iframe);
    //         }
    //     } catch (error) {
    //         console.error('Download failed:', error);
    //     }
    // };

    const downloadMultipleFiles = async () => {
        try {
            setIsDownloading(bookingDetail?.uuid)
            const fullPath = ticketFullPath;
            if (fullPath) {
                window.open(fullPath, '_blank').focus();
                setIsDownloading("")
            }
            // const response = await axios.post(
            //     helper.ApiUrl + 'bookings/genrate-tickets',
            //     { bookingId: bookingDetail?.uuid },
            //     {
            //         headers: {
            //             'Authorization': `Bearer ${user.token}`,
            //             'Accept': 'application/json',
            //         },
            //     }
            // );

            // const fullPath = response?.data?.fullPath
            // if (fullPath) {
            //     window.open(fullPath, '_blank').focus();
            //     setIsDownloading("")
            // } else {
            //     const url = response.data.url;

            //     if (url) {
            //         const iframe = document.createElement('iframe');
            //         iframe.style.display = 'none';
            //         iframe.src = url + '&response-content-disposition=attachment';
            //         document.body.appendChild(iframe);

            //         // Clean up after 1 second
            //         setTimeout(() => {
            //             document.body.removeChild(iframe);
            //         }, 1000);
            //         setIsDownloading("")
            //     } else {
            //         setIsDownloading("")
            //         console.error('No URL returned');
            //     }
            // }


        } catch (error) {
            setIsDownloading("")
            console.error('Download failed:', error);
        }
    };




    return (
        <>
            <PageTitle title={'Booking Success'} />
            <Index
                breadcrumbList={breadcrumbList}
                bookingDetail={bookingDetail}
                isLoading={isLoading}
                downloadMultipleFiles={downloadMultipleFiles}
                isTicketGenerated={isTicketGenerated}
                isDownloading={isDownloading}
            />
        </>
    )

}